// Footer Component
document.addEventListener('DOMContentLoaded', function() {
  if (!document.getElementById('footer')) {
    createFooter();
  }

  // Update .js-user-count / #user-count from API (cached 24h). Prefer watching
  // the first visible count node so mid-page headlines update without waiting for footer.
  var countTarget =
    document.querySelector('.js-user-count') ||
    document.getElementById('user-count') ||
    document.getElementById('footer');

  if (countTarget && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function(entries) {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          fetchUserCount();
        }
      },
      { rootMargin: '120px', threshold: 0 }
    );
    observer.observe(countTarget);
  } else {
    var runWhenIdle = window.requestIdleCallback || function(fn) { setTimeout(fn, 1); };
    runWhenIdle(function() { fetchUserCount(); }, { timeout: 3000 });
  }
});

// Cache key for storing user count in localStorage
const USER_COUNT_CACHE_KEY = 'billspot_user_count';
// Cache expiration time in milliseconds (24 hours)
const CACHE_EXPIRATION = 24 * 60 * 60 * 1000;

function createFooter() {
  const year = new Date().getFullYear();
  const footerHTML = `
  <footer id="footer" class="site-footer">
    <div class="site-footer-inner">
      <div class="site-footer-grid">
        <div class="site-footer-brand">
          <a href="/" class="site-footer-logo">
            <img src="/images/logo.png" alt="BillSpot" width="1251" height="573" decoding="async" />
          </a>
          <p class="site-footer-tagline">One wallet for airtime, bills, and cash.</p>
          <p class="site-footer-note">BillSpot Digital Limited is a financial technology company, not a bank. Payment partners are licensed. <a href="/trust">Trust &amp; security</a></p>
        </div>

        <div class="site-footer-col">
          <h3>Products</h3>
          <ul>
            <li><a href="/airtime-to-cash">Airtime to Cash</a></li>
            <li><a href="/buy-airtime-data">Airtime &amp; Data</a></li>
            <li><a href="/pay-bills">Pay Bills</a></li>
            <li><a href="/wallet">Wallet</a></li>
            <li><a href="/cards">Cards</a></li>
          </ul>
        </div>

        <div class="site-footer-col">
          <h3>Company</h3>
          <ul>
            <li><a href="/trust">Trust</a></li>
            <li><a href="/roadmap">Roadmap</a></li>
            <li><a href="/faq">FAQ</a></li>
            <li><a href="/policy">Privacy Policy</a></li>
            <li><a href="/terms">Terms of Service</a></li>
          </ul>
        </div>

        <div class="site-footer-col">
          <h3>More</h3>
          <ul>
            <li><a href="/transfers">Transfers</a></li>
            <li><a href="/withdraw">Withdraw</a></li>
            <li><a href="/usd-account">USD Account</a></li>
            <li><a href="/gift-drop">BGiftDrop</a></li>
            <li><a href="/spray-it">Spray It</a></li>
            <li><a href="/referrals">Referrals</a></li>
          </ul>
        </div>

        <div class="site-footer-col site-footer-contact">
          <div class="site-footer-social" aria-label="Social links">
            <a href="https://facebook.com/BillSpot_app" target="_blank" rel="noopener noreferrer" aria-label="BillSpot on Facebook"><svg xmlns:xlink="http://www.w3.org/1999/xlink" class="ico ico-fill" aria-hidden="true"><use href="/images/icons.svg#ico-facebook" xlink:href="/images/icons.svg#ico-facebook"></use></svg></a>
            <a href="https://x.com/BillSpot_app" target="_blank" rel="noopener noreferrer" aria-label="BillSpot on X"><svg class="icon-x" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg></a>
            <a href="https://instagram.com/BillSpot_app" target="_blank" rel="noopener noreferrer" aria-label="BillSpot on Instagram"><svg xmlns:xlink="http://www.w3.org/1999/xlink" class="ico" aria-hidden="true"><use href="/images/icons.svg#ico-instagram" xlink:href="/images/icons.svg#ico-instagram"></use></svg></a>
            <a href="https://wa.me/2347073602116" target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp"><svg xmlns:xlink="http://www.w3.org/1999/xlink" class="ico ico-fill" aria-hidden="true"><use href="/images/icons.svg#ico-whatsapp" xlink:href="/images/icons.svg#ico-whatsapp"></use></svg></a>
          </div>
          <ul>
            <li><a href="mailto:support@billspot.co">support@billspot.co</a></li>
            <li><a href="tel:+2347073602116">(+234) 707 360 2116</a></li>
            <li>Onitsha, Anambra, Nigeria</li>
          </ul>
        </div>
      </div>

      <div class="site-footer-bottom">
        <p>&copy; ${year} · BillSpot Digital Limited · RC 8246077</p>
        <p class="site-footer-trademark">Trademark: NG/TM/O/2025/407638</p>
      </div>
    </div>
  </footer>
  `;

  document.body.insertAdjacentHTML('beforeend', footerHTML);
}

function fetchUserCount() {
  const cachedData = getCachedUserCount();
  if (cachedData !== null && cachedData !== undefined) {
    updateUserCountDisplay(cachedData);
    return;
  }

  if (window.location.protocol === 'file:') {
    const mockCount = simulateUserCount();
    cacheUserCount(mockCount);
    return;
  }

  try {
    fetchFromApi();
  } catch (error) {
    console.error('Error in fetch setup:', error);
    const mockCount = simulateUserCount();
    cacheUserCount(mockCount);
  }
}

function getCachedUserCount() {
  try {
    const cachedData = localStorage.getItem(USER_COUNT_CACHE_KEY);
    if (!cachedData) return null;

    const { count, timestamp } = JSON.parse(cachedData);
    const now = new Date().getTime();

    if (now - timestamp < CACHE_EXPIRATION) {
      return count;
    }

    localStorage.removeItem(USER_COUNT_CACHE_KEY);
    return null;
  } catch (error) {
    console.error('Error reading from cache:', error);
    return null;
  }
}

function cacheUserCount(count) {
  try {
    const data = {
      count: count,
      timestamp: new Date().getTime()
    };
    localStorage.setItem(USER_COUNT_CACHE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error('Error caching user count:', error);
  }
}

function simulateUserCount() {
  const mockCount = 1000000;
  updateUserCountDisplay(mockCount);
  return mockCount;
}

function fetchFromApi() {
  const apiUrl = 'https://app.billspot.co/api/v1/auth/get-user-counts';

  fetch(apiUrl, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      if (data && data.counts) {
        const userCount = parseInt(data.counts);
        updateUserCountDisplay(userCount);
        cacheUserCount(userCount);
      } else {
        throw new Error('Invalid data format');
      }
    })
    .catch(error => {
      console.error('Error fetching user count:', error);
      const mockCount = simulateUserCount();
      cacheUserCount(mockCount);
    });
}

function updateUserCountDisplay(count) {
  let displayCount;
  const n = Number(count) || 0;

  if (n >= 1000000) {
    displayCount = Math.floor(n / 1000000) + 'M+';
  } else if (n >= 1000) {
    displayCount = Math.floor(n / 1000) + 'K+';
  } else if (n > 0) {
    displayCount = String(n);
  } else {
    displayCount = '1M+';
  }

  const userCountElement = document.getElementById('user-count');
  if (userCountElement) {
    userCountElement.textContent = displayCount;
  }
  document.querySelectorAll('.js-user-count').forEach(function (el) {
    el.textContent = displayCount;
  });
}
